import { Box, Snackbar, Alert } from '@mui/material';
import PublishIcon from '@mui/icons-material/Publish';
import {
  FormTitleBox,
  HeaderFilterBox,
  GeneralTableBox,
  LoadingSkeleton,
  TableBodySkeleton,
} from '../../common/components';
import RegisterPaymentFilters from './components/RegisterPaymentFilters';
import ContractSelector from './components/ContractSelector';
import ConsolidateButton from './components/ConsolidateButton';
import RegisterPaymentDataTable from './components/RegisterPaymentDataTable';
import SaveCollectionModal from './components/SaveCollectionModal';
import DuplicateAlertDialog from './components/DuplicateAlertDialog';
import { useRegisterPaymentTable } from './hooks/useRegisterPayment';
import { RESPONSIVE_CONFIG, ICONS_CONFIG } from '../../common';

const RegisterPaymentTable = () => {
  const {
    // Data siguiendo el patrón
    data,
    isLoading,
    filter,

    // Datos específicos del módulo
    tableData,
    totalCupones,
    totalAmount,
    contratoSeleccionado,
    customAmount,
    searchTerm,
    isSearching,
    consolidateDate,
    selectedDate,
    selectedCobroDate,
    entidadSeleccionada,
    selectedSalePoint,
    makeElectronicInvoice,
    saveModal,
    showDuplicateAlert,
    snackbar,
    isNaranjaX,

    // External data
    plans,
    recLegalEntities,
    salePoints,

    // Actions
    handleFilter,
    setTableData,
    setSearchTerm,
    setIsSearching,
    setConsolidateDate,
    setSelectedDate,
    setSelectedCobroDate,
    setEntidadSeleccionada,
    setMakeElectronicInvoice,
    setShowDuplicateAlert,
    handleCloseSnackbar,
    handleContratoChange,
    handleImporteChange,
    handleRegistrarClick,
    handleDeleteCoupon,
    handleSalePointChange,
    handleConsolidate,
    handleSaveCollection,
    handleClearAll,
    closeSaveModal,
    handleNavigateToPayments,

    // Refs
    searchTimeoutRef,
  } = useRegisterPaymentTable();

  return (
    <>
      <FormTitleBox
        title="Habitat 99 | Registrar | Registrar cobro"
        showButton={true}
        buttonText="Guardar Cobranza"
        buttonIcon={PublishIcon}
        onButtonClick={handleSaveCollection}
        buttonProps={{
          sx: {
            fontSize: RESPONSIVE_CONFIG.HEADER.buttonFontSize,
            padding: RESPONSIVE_CONFIG.HEADER.buttonPadding,
          },
        }}
        iconProps={{
          sx: ICONS_CONFIG.BASE,
        }}
      />

      <HeaderFilterBox variant='twoRows'>
        <RegisterPaymentFilters
          filter={filter}
          handleFilter={handleFilter}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          selectedCobroDate={selectedCobroDate}
          setSelectedCobroDate={setSelectedCobroDate}
          entidadSeleccionada={entidadSeleccionada}
          setEntidadSeleccionada={setEntidadSeleccionada}
          selectedSalePoint={selectedSalePoint}
          handleSalePointChange={handleSalePointChange}
          makeElectronicInvoice={makeElectronicInvoice}
          setMakeElectronicInvoice={setMakeElectronicInvoice}
          handleClearAll={handleClearAll}
          plans={plans}
          recLegalEntities={recLegalEntities}
          salePoints={salePoints}
          isNaranjaX={isNaranjaX}
        />
      </HeaderFilterBox>

      <Box>
        {isNaranjaX ? (
          <ConsolidateButton
            handleConsolidate={handleConsolidate}
            consolidateDate={consolidateDate}
            setConsolidateDate={setConsolidateDate}
          />
        ) : (
          <ContractSelector
            contratoSeleccionado={contratoSeleccionado}
            handleContratoChange={handleContratoChange}
            handleRegistrarClick={handleRegistrarClick}
            customAmount={customAmount}
            handleImporteChange={handleImporteChange}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            isSearching={isSearching}
            setIsSearching={setIsSearching}
            searchTimeoutRef={searchTimeoutRef}
            handleFilter={handleFilter}
            contracts={data}
            selectedCobroDate={selectedCobroDate}
          />
        )}
      </Box>

      <GeneralTableBox>
        <RegisterPaymentDataTable
          data={tableData}
          isLoading={isLoading}
          handleDeleteCoupon={handleDeleteCoupon}
          totalCupones={totalCupones}
          totalAmount={totalAmount}
          LoadingComponent={TableBodySkeleton}
        />
      </GeneralTableBox>

      <SaveCollectionModal
        open={saveModal.open}
        onClose={closeSaveModal}
        loading={saveModal.loading}
        result={saveModal.result}
        error={saveModal.error}
        tableData={tableData}
        setTableData={setTableData}
        selectedSalePoint={selectedSalePoint}
        onNavigateToPayments={handleNavigateToPayments}
      />

      <DuplicateAlertDialog
        open={showDuplicateAlert}
        onClose={() => setShowDuplicateAlert(false)}
      />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default RegisterPaymentTable;
